import { InterviewResponseSchema } from "@workspace/dto/message/respond-to-interview";
import { z } from "zod";
import { buildFromAddress } from "../utils/build-email-address";
import { defineEmailNotificationHandler } from "./types";

const InterviewStatusChangedSchema = z.object({
  conversationId: z.string(),
  interviewId: z.string(),
  interviewTitle: z.string(),
  candidateName: z.string(),
  response: InterviewResponseSchema,
});

function getResponseDescription(metadata: Record<string, unknown>): string {
  const candidateName = String(metadata.candidateName);
  switch (metadata.response) {
    case "accept":
      return `${candidateName} will attend the interview.`;
    case "request_new_time":
      return `${candidateName} requested another interview time.`;
    case "decline":
      return `${candidateName} cannot attend the interview.`;
    default:
      return `${candidateName} responded to the interview invite.`;
  }
}

export const interviewStatusChangedHandler = defineEmailNotificationHandler({
  type: "interview.status_changed",
  icon: "interview",
  title(metadata) {
    return `${String(metadata.candidateName)} responded to ${String(
      metadata.interviewTitle
    )}`;
  },
  description: getResponseDescription,
  schema: InterviewStatusChangedSchema,
  buildNotificationPayload(data, _ctx) {
    return {
      metadata: {
        conversationId: data.conversationId,
        interviewId: data.interviewId,
        interviewTitle: data.interviewTitle,
        candidateName: data.candidateName,
        response: data.response,
      },
      links: {
        href: `/conversations/${data.conversationId}`,
        label: "View conversation",
      },
    };
  },
  buildEmailPayload(data, recipient, { baseUrl }) {
    return {
      id: `interview-response:${data.interviewId}:${recipient.userId}:${data.response}`,
      name: "email/interview.response",
      data: {
        to: recipient.email ?? "",
        from: buildFromAddress(),
        recipientName: recipient.name ?? "there",
        candidateName: data.candidateName,
        interviewTitle: data.interviewTitle,
        response: data.response,
        conversationUrl: `${baseUrl}/conversations/${data.conversationId}`,
      },
    };
  },
});
